import React from 'react';
import type { ReactElement } from 'react';
import { Navigate } from 'react-router';

import { ProtectedResourceId } from '@api/types/user/userAccessRights';
import { ROUTES } from '@config/routes';

import { useGrantAccess } from '../logic/useGrantAccess';

type GrantAccessOrRedirectProps = {
  children: ReactElement;
  resourceId: ProtectedResourceId;
};

export const GrantAccessOrRedirect = ({ children, resourceId }: GrantAccessOrRedirectProps) => {
  const canDisplay = useGrantAccess({ resourceId });

  if (!canDisplay) {
    return <Navigate to={ROUTES.NOT_FOUND} replace />;
  }

  return children;
};
